import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'react-hot-toast';

// Layout
import Layout from './components/Layout';
import PasswordGate from './components/PasswordGate';

// Pages
import HomePage from './pages/HomePage';
import ComplexesPage from './pages/ComplexesPage';
import ComplexDetailPage from './pages/ComplexDetailPage';
import CardsPage from './pages/CardsPage';
import CardDetailPage from './pages/CardDetailPage';
import MapToolsPage from './pages/MapToolsPage';
import StatsPage from './pages/StatsPage';
import MapMetaPage from './pages/MapMetaPage';
import OfficetelZonePage from './pages/OfficetelZonePage';
import FieldSurveyPage from './pages/FieldSurveyPage';
import FieldSurveyHistoryPage from './pages/FieldSurveyHistoryPage';
import FieldSurveyMapPage from './pages/FieldSurveyMapPage';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <PasswordGate>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <div className="App">
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<HomePage />} />
                <Route path="complexes" element={<ComplexesPage />} />
                <Route path="complexes/:id" element={<ComplexDetailPage />} />
                <Route path="cards" element={<CardsPage />} />
                <Route path="cards/:id" element={<CardDetailPage />} />
                <Route path="map-tools" element={<MapToolsPage />} />
                <Route path="map-meta" element={<MapMetaPage />} />
                <Route path="officetel-zones" element={<OfficetelZonePage />} />
                <Route path="field-survey" element={<FieldSurveyPage />} />
                <Route path="field-survey/:id" element={<FieldSurveyPage />} />
                <Route path="field-survey/history" element={<FieldSurveyHistoryPage />} />
                <Route path="field-survey/map" element={<FieldSurveyMapPage />} />
                <Route path="stats" element={<StatsPage />} />
              </Route>
            </Routes>
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
              }}
            />
          </div>
        </Router>
        <ReactQueryDevtools initialIsOpen={false} />
      </PasswordGate>
    </QueryClientProvider>
  );
}

export default App;
